<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      classeRadio(valor) {
            if (typeof(valor) == "string")
                return valor == "true" ? 'Sim' : 'Não'    
            else
                return valor ? 'Sim' : 'Não';
      },
      classBoolean(valor) {
            if (typeof(valor) == "string")
                return valor    
            else
                return valor ? 'true' : 'false';
      }
    }
  }
</script>

<template>
    <div>
        <dl v-if="configuracao.solicitacaoUtilizaSelecaoTipoCompra">
            <dt>Tipo de compra</dt>
            <dd>Compras online</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="item.rubrica !== null">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Observação:</dt>
            <dd class="white-space-pre">Compras Online são permitidas apenas para empresas que emitem faturas para Pessoas Jurídicas</dd>
        </dl>

        <dl>
            <dt>Executora</dt>
            <dd class="white-space-pre">{{ !item.executora ? "---" : item.executora == '1' ? "FUSP" : "Projeto" }}</dd>
        </dl>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Descrição do material/serviço</dt>
            <dd class="white-space-pre">{{ item.descricao }}</dd>
        </dl>

        <div class="row">
            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                <dt>Quantidade</dt>
                <dd>{{ item.quantidade || '---' }}</dd>
            </dl>

            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                <dt>Unidade</dt>
                <dd>{{ item.unidade || '---' }}</dd>
            </dl>

            <dl class="col-xs-4" v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>{{ item.valorEstimado ? `R$ ${item.valorEstimado}` : '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-xs-3" v-if="item.executora == '2'">
                <dt>Empresa do site</dt>
                <dd>{{ item.empresaProduto || '---' }}</dd>
            </dl>

            <dl :class="[item.executora == '1' ? 'col-xs-12' : 'col-xs-9']">
                <dt>Link do produto</dt>
                <dd>{{ item.linkProduto || '---' }}</dd>
            </dl>
        </div>

     
        <div v-if="item.executora === '1'">
            <dl>
                <dt>O Projeto aceita retirar a(s) mercadoria(s) no endereço do CNPJ faturado (Av. Afrânio Peixoto, 14 - Butantã, São Paulo/SP - CEP 05507-000)?</dt>
                <dd>
                    {{ classeRadio(item.projetoAceitarRetirarMercadoria) }}
                </dd>
            </dl>

            <dl v-if="classBoolean(item.projetoAceitarRetirarMercadoria) == 'false'">
                <dt>Endereço de entrega</dt>
                <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
            </dl>

            <div class="row">
                <dl class="col-xs-4">
                    <dt>O Projeto aceita variação de preço no momento da compra?</dt>
                    <dd>
                        {{ classeRadio(item.projetoAceitarVariacaoPreco) }}
                    </dd>
                </dl>

                <dl class="col-xs-2" v-if="classBoolean(item.projetoAceitarVariacaoPreco) == 'true'">
                    <dt>Percentual variação de preço</dt>
                    <dd class="white-space-pre">{{ item.percentualVariacaoValor || '---' }}%</dd>
                </dl>
            </div>

            <div class="row">
                <dl class="col-xs-4">
                    <dt>O Projeto aceita pagar frete?</dt>
                    <dd>
                        {{ classeRadio(item.projetoAceitarFrete) }}
                    </dd>
                </dl>

                <dl class="col-xs-2" v-if="classBoolean(item.projetoAceitarFrete) == 'true'">
                    <dt>Percentual variação do frete</dt>
                    <dd class="white-space-pre">{{ item.percentualVariacaoFrete || '---' }}%</dd>
                </dl>
            </div>

            <dl>
                <dt>A FUSP será responsável por realizar a compra, inserir a solicitação de pagamento, acompanhar a entrega e informar o Projeto sobre a entrega ou retirada.</dt>
            </dl>
        </div>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Local que o material será alocado</dt>
            <dd class="white-space-pre">{{ item.localAlocado || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaComprasOnline.vue